/* eslint-disable-next-line no-restricted-imports -- the only place where we
need to use the original `createAsyncThunk()` */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'reducers/root';
import { AppDispatch } from 'store';

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  dispatch: AppDispatch;
  state: RootState;
}>();
